import React from 'react';
import { IconProps } from '../types';

const PortfolioBuilderIcon = ({
  width = '18px',
  height = '21px',
  color
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 21 21"
      version="1.1"
    >
      <g
        id="Full-Prototype-Spec"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Step-1---Risk-Profile"
          transform="translate(-25.000000, -375.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g id="Sidebar">
            <g id="Menu-Icons" transform="translate(24.000000, 58.000000)">
              <g id="Success-Icon" transform="translate(1.000000, 317.000000)">
                <path
                  d="M10.5,0 C4.71046154,0 0,4.71005769 0,10.5 C0,16.2899423 4.71046154,21 10.5,21 C16.2895385,21 21,16.2899423 21,10.5 C21,4.71005769 16.2895385,0 10.5,0 Z M10.5,20.1923077 C5.15590385,20.1923077 0.807692308,15.8440962 0.807692308,10.5 C0.807692308,5.15590385 5.15590385,0.807692308 10.5,0.807692308 C15.8440962,0.807692308 20.1923077,5.15590385 20.1923077,10.5 C20.1923077,15.8440962 15.8440962,20.1923077 10.5,20.1923077 Z"
                  id="Shape"
                ></path>
                <path
                  d="M15.4476508,6.59741928 L9.24113409,13.5797535 L5.50203994,10.5885361 C5.32839155,10.4492125 5.07357263,10.4778849 4.93465391,10.6515346 C4.79533136,10.825992 4.82359971,11.0800052 4.99765193,11.2193288 L9.03598669,14.4500213 C9.11029205,14.5093853 9.19953924,14.5384615 9.28838261,14.5384615 C9.39984065,14.5384615 9.51089485,14.4924242 9.59045005,14.4027725 L16.0517857,7.13371424 C16.1999925,6.96733357 16.1850507,6.71170502 16.0182675,6.56390084 C15.8510804,6.41528898 15.5962615,6.43023094 15.4476508,6.59741928 Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default PortfolioBuilderIcon;
